<template>
    <div class="page-workout" v-if="activeWorkout">
        <div class="page-workout__header">
            <WorkoutCard :workout="activeWorkout" layout="header">
                <a href="javascript:void(0);" @click="$root.returnToPreviousPage()" class="btn btn-outline">{{ $root.t('Voltar para os treinos') }}</a>
            </WorkoutCard>
        </div>
        <TreineBanners area="topo-videos" class="banner-container topo-videos-banner"></TreineBanners>
        <br/>
        <TopoVideosBanner area="ebook-banner" class="banner-container"></TopoVideosBanner>
        <div class="page-workout__body" v-if="activeWorkout.videos">
            <div class="container">
                <div class="page-workout__body__wrapper">
                    <div v-for="video in activeWorkout.videos.slice(0,videosToShow)" :key="video.videoId.query">
                        <WorkoutVideoCard :workoutId="activeWorkout.slug" :video="video"></WorkoutVideoCard>
                    </div>

                    <button v-if="canLoadMoreVideos" @click="showMoreVideos()" class="page-workout__body__show-more-videos">
                        {{ $root.t('Carregar Mais') }}
                    </button>
                </div>
            </div>
        </div>

        <div class="page-workout__banner">
            <TreineBanners area="listagem-de-video"></TreineBanners>
        </div>

    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import WorkoutCard from '@/components/WorkoutCard'
import WorkoutVideoCard from '@/components/WorkoutVideoCard'
import TreineBanners from "@/components/TreineBanners";
import TopoVideosBanner from "@/components/TopoVideosBanner";

export default {
    components : {
        WorkoutCard, WorkoutVideoCard, TreineBanners, TopoVideosBanner
    },
    data () {
        return {
            workoutId : this.$route.params.id,
            canLoadMoreVideos: false,
            videosToShow: 4,
        }
    },
    computed : {
        ...mapGetters([
            'activeWorkout',
            'workouts',
        ]),
    },
    watch : {
        workouts () {
            this.setActiveWorkout(this.workoutId)
        },
        activeWorkout() {
            if(this.activeWorkout) {
                this.canLoadMoreVideos = this.activeWorkout.videos.length > this.videosToShow
            }
        }
    },
    methods : {
        ...mapActions({
            setActiveWorkout : 'setActiveWorkout'
        }),
        showMoreVideos() {
            const videoIncrement = 4
            this.videosToShow = videoIncrement + this.videosToShow
            this.canLoadMoreVideos = this.activeWorkout.videos.length > this.videosToShow
        },
    },
    created () {
        this.setActiveWorkout(this.workoutId)
    }
}
</script>

<style lang="scss" scoped>
    .page-workout {
        &__header {
            width: 100%;
            height: 100vw;
            max-height: 700px;

            @include desktop {
                height: 80vh;
            }
        }

        &__body {
            background: #111111;

            &__wrapper {
                display: grid;
                grid-gap: 30px;
                padding: 70px 0 30px;
            }

            &__show-more-videos {
                border: 1px solid #404040;
                box-sizing: border-box;
                border-radius: 4px;
                padding: 16px 50px;
                background: transparent;
                justify-self: center;
                color: white;
                font-weight: bold;
                text-transform: uppercase;
                cursor: pointer;
            }
        }

        &__banner {
            background: #111111;
            padding: 10px 0;
        }
    }
</style>
